import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-77c9060a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mt-4" }
const _hoisted_2 = { class: "col-md-12 text-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Área do Cliente")
  ])
], -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_11 = {
  key: 0,
  class: "row",
  id: "divHome"
}
const _hoisted_12 = { class: "col-md-2 col-6" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo" }, "Meu Cadastro", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-3" }, null, -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "col-md-2 col-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo" }, "Meus Dependentes", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-people" }, null, -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "col-md-2 col-6" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo" }, "Meus Boletos", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-document" }, null, -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "col-md-2 col-6" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo" }, "Meus Contratos", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-document" }, null, -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "col-md-2 col-6" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo" }, "Alterar Senha", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-lock" }, null, -1))
const _hoisted_31 = { class: "col-md-2 col-6" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo" }, "Sair", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow-1" }, null, -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "row",
  id: "divMeusDados"
}
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "card" }
const _hoisted_38 = { class: "card-body" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Dados do Cliente", -1))
const _hoisted_40 = { class: "col-md-12 dados-cliente" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { key: 3 }
const _hoisted_45 = { key: 4 }
const _hoisted_46 = { key: 5 }
const _hoisted_47 = { key: 6 }
const _hoisted_48 = { key: 7 }
const _hoisted_49 = { key: 8 }
const _hoisted_50 = { key: 9 }
const _hoisted_51 = { key: 10 }
const _hoisted_52 = { key: 11 }
const _hoisted_53 = { key: 12 }
const _hoisted_54 = { key: 13 }
const _hoisted_55 = { key: 14 }
const _hoisted_56 = { class: "col-md-12 mt-3 d-grid gap-2 d-sm-block" }
const _hoisted_57 = {
  key: 2,
  class: "row",
  id: "divMeusDependentes"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Meus Dependentes")
], -1))
const _hoisted_59 = { class: "card mb-2" }
const _hoisted_60 = { class: "card-body" }
const _hoisted_61 = { class: "card-title" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-md-6 col-6" }
const _hoisted_64 = { class: "col-md-6 col-6" }
const _hoisted_65 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_66 = { class: "col-md-12 mt-3 d-grid gap-2 d-sm-block" }
const _hoisted_67 = {
  key: 3,
  class: "row",
  id: "divMeusContratos"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Meus Contratos")
], -1))
const _hoisted_69 = { class: "card" }
const _hoisted_70 = { class: "card-body" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-md-4" }
const _hoisted_73 = { class: "card-title" }
const _hoisted_74 = { class: "col-md-4" }
const _hoisted_75 = { class: "card-title" }
const _hoisted_76 = { class: "col-md-4" }
const _hoisted_77 = { class: "card-title" }
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-md-4" }
const _hoisted_80 = { class: "col-md-4 col-6" }
const _hoisted_81 = { class: "col-md-4 col-6" }
const _hoisted_82 = { class: "row" }
const _hoisted_83 = { class: "col-md-4" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, null, -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, null, -1))
const _hoisted_86 = { class: "row mt-2" }
const _hoisted_87 = { class: "col-md-6 col-6" }
const _hoisted_88 = { class: "col-md-6 col-6 text-end" }
const _hoisted_89 = { class: "col-md-12 mt-3 d-grid gap-2 d-sm-block" }
const _hoisted_90 = {
  key: 4,
  class: "row",
  id: "divMeusBoletos"
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Meus Boletos")
], -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "" }, "A Pagar")
], -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Pagas")
], -1))
const _hoisted_94 = { class: "col-md-12 mt-3 mb-3 d-grid gap-2 d-sm-block" }
const _hoisted_95 = {
  key: 5,
  class: "row mt-2 mb-2",
  id: "divParceiros"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-2" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Parceiros")
], -1))
const _hoisted_97 = { class: "col-md-3 mb-2" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search" }),
  /*#__PURE__*/_createTextVNode(" Pesquisar ")
], -1))
const _hoisted_99 = { class: "col-md-3 mb-2" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search" }),
  /*#__PURE__*/_createTextVNode(" Categoria ")
], -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "- Todas Categorias - ", -1))
const _hoisted_102 = ["value"]
const _hoisted_103 = { class: "col-md-3 mb-2" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-marker" }),
  /*#__PURE__*/_createTextVNode(" Cidade ")
], -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "- Todas Cidades - ", -1))
const _hoisted_106 = ["value"]
const _hoisted_107 = { class: "col-md-3" }
const _hoisted_108 = { class: "card mb-4" }
const _hoisted_109 = ["src"]
const _hoisted_110 = { class: "card-body" }
const _hoisted_111 = { class: "card-title fw-bold" }
const _hoisted_112 = { class: "card-text endereco mb-0" }
const _hoisted_113 = { class: "card-text cidade mb-0" }
const _hoisted_114 = {
  key: 0,
  class: "card-text desconto mb-0 fw-bold"
}
const _hoisted_115 = {
  key: 1,
  class: "card-text desconto mb-0 fw-bold mt-3"
}
const _hoisted_116 = {
  class: "card-text telefone mt-2 mb-3fw-bold",
  title: "Telefone"
}
const _hoisted_117 = { class: "text-center mt-2" }
const _hoisted_118 = { key: 0 }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, " Nenhum parceiro encontrado. ", -1))
const _hoisted_120 = [
  _hoisted_119
]
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fw-bold fs-5" }, " Deseja realmente sair? ")
], -1))

import { reactive, onMounted } from "vue";

//services
import * as clienteService from "@/services/clienteService";
import storeControle from "@/utils/storeControle";

import { f2dec, fdata, fdataHora } from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";
import imgSemImagem from "@/assets/images/sem-imagem.gif";

import Parcela from "./Parcela.vue";
import MsgBox from "@/components/MsgBox/Index.vue";

import config from "@/app.config.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

//vue
const controle = reactive({
    dadosCliente: null as clienteService.DadosCliente | null,
    parceiros: [] as clienteService.Parceiro[],
    filtrosParceiros: {
        pesquisa: "",
        categoriaId: null as number | null,
        cidadeId: null as number | null,
        paginaAtual: 1,
        tamanhoPagina: 12
    } as clienteService.ClienteParceirosFiltros,
    dataBoletoAntigo: new Date(2026, 7, 1),
    totalParceiros: 0,
    cidades: [] as clienteService.Cidade[],
    ver: "" as string,
    status: "" as string,
    erro: "" as string,
    janSair: false as boolean
});

onMounted(() => {
    buscarDadosCliente();
    buscarParceiros();
    buscarCidades();
});

function buscarDadosCliente() {
    // Lógica para buscar os dados do cliente
    console.log("Buscando dados do cliente...");
    controle.status = "Buscando dados do cliente...";
    clienteService.obterDados()
        .then((r) => {
            console.log("Dados do cliente:", r);
            controle.status = "";
            controle.dadosCliente = r;
        })
        .catch((error) => {
            console.error("Erro ao buscar dados do cliente:", error);
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
            setTimeout(() => {
                //sair();
                console.log("Redirecionar para login...");
            }, 4000);
        });
}



function buscarParceiros() {
    // Lógica para buscar os parceiros do cliente
    console.log("Buscando parceiros do cliente...");
    controle.status = "Buscando parceiros do cliente...";

    if (controle.filtrosParceiros.cidadeId != null) {
        controle.filtrosParceiros.paginaAtual = 1;
        controle.filtrosParceiros.tamanhoPagina = 300;
    }
    else {
        controle.filtrosParceiros.paginaAtual = 1;
        controle.filtrosParceiros.tamanhoPagina = 16;
    }
    clienteService.obterParceiros(controle.filtrosParceiros)
        .then((r) => {
            console.log("Parceiros do cliente:", r);
            controle.status = "";
            controle.parceiros = r.dados;
            controle.totalParceiros = r.totalRegistros;
        })
        .catch((error) => {
            console.error("Erro ao buscar parceiros do cliente:", error);
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function verTodosParceiros() {
    controle.filtrosParceiros.pesquisa = "";
    controle.filtrosParceiros.categoriaId = null;
    controle.filtrosParceiros.cidadeId = null;
    controle.filtrosParceiros.paginaAtual = 1;
    controle.filtrosParceiros.tamanhoPagina = 300;

    controle.status = "Buscando parceiros do cliente...";
    clienteService.obterParceiros(controle.filtrosParceiros)
        .then((r) => {
            controle.status = "";
            controle.parceiros = r.dados;
            controle.totalParceiros = r.totalRegistros;
        })
        .catch((error) => {
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function buscarCidades() {
    // Lógica para buscar as cidades
    console.log("Buscando cidades...");
    controle.status = "Buscando cidades...";
    clienteService.obterCidades()
        .then((r) => {
            controle.status = "";
            controle.cidades = r;
        })
        .catch((error) => {
            console.error("Erro ao buscar cidades:", error);
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function pergSair() {
    controle.janSair = true;
}

function sair() {
    // Lógica para sair da área do cliente
    controle.janSair = false;
    controle.status = "Saindo...";
    console.log("Saindo da área do cliente...");
    localStorage.removeItem("clienteToken");
    localStorage.removeItem("user");
    storeControle.token = "";
    window.location.reload();
}




return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(imgLogin),
          alt: "Logo",
          class: "img-fluid img-logo mb-3"
        }, null, 8, _hoisted_3)
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, " Bem-vindo, " + _toDisplayString(controle.dadosCliente ? controle.dadosCliente.cliente.nome : 'Cliente') + "! ", 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (controle.erro == '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_9, _toDisplayString(controle.status), 1))
          : _createCommentVNode("", true),
        (controle.erro != '')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_10, _toDisplayString(controle.erro), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (controle.ver == '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (controle.ver = 'meusDados'))
            }, _hoisted_15)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (controle.ver = 'meusDependentes'))
            }, _hoisted_19)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (controle.ver = 'meusBoletos'))
            }, _hoisted_23)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (controle.ver = 'meusContratos'))
            }, _hoisted_27)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_RouterLink, {
              class: "botao-menu",
              to: { name: 'PainelClienteAlterarSenha' }
            }, {
              default: _withCtx(() => [
                _hoisted_29,
                _hoisted_30
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("a", {
              class: "botao-menu",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (pergSair()))
            }, _hoisted_34)
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == 'meusDados')
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", null, " Nome: " + _toDisplayString(controle.dadosCliente?.cliente.nome), 1),
                  _createElementVNode("div", null, " CPF: " + _toDisplayString(controle.dadosCliente?.cliente.cpf), 1),
                  (controle.dadosCliente?.cliente.rg)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, " RG: " + _toDisplayString(controle.dadosCliente?.cliente.rg), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosCliente?.cliente.rgExpedidor)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, " RG Expedidor: " + _toDisplayString(controle.dadosCliente?.cliente.rgExpedidor), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosCliente?.cliente.email)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, " Email: " + _toDisplayString(controle.dadosCliente?.cliente.email), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosCliente?.cliente.telefone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, " Telefone: " + _toDisplayString(controle.dadosCliente?.cliente.telefone), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosCliente?.cliente.logradouro)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, " Logradouro: " + _toDisplayString(controle.dadosCliente?.cliente.logradouro), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosCliente?.cliente.numero)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, " Número: " + _toDisplayString(controle.dadosCliente?.cliente.numero), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosCliente?.cliente.bairro)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, " Bairro: " + _toDisplayString(controle.dadosCliente?.cliente.bairro), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosCliente?.cliente.complemento)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, " Complemento: " + _toDisplayString(controle.dadosCliente?.cliente.complemento), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosCliente?.cliente.cidade)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, " Cidade: " + _toDisplayString(controle.dadosCliente?.cliente.cidade), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosCliente?.cliente.estado)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, " Estado: " + _toDisplayString(controle.dadosCliente?.cliente.estado), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosCliente?.cliente.cep)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, " CEP: " + _toDisplayString(controle.dadosCliente?.cliente.cep), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosCliente?.cliente.dataNascimento)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, " Data Nascimento: " + _toDisplayString(_unref(fdata)(controle.dadosCliente?.cliente.dataNascimento)), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosCliente?.cliente.dataEntregaCartao)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, " Data Entrega Cartão: " + _toDisplayString(_unref(fdata)(controle.dadosCliente?.cliente.dataEntregaCartao)), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosCliente?.cliente.nomeConjuge)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, " Nome Conjuge: " + _toDisplayString(controle.dadosCliente?.cliente.nomeConjuge), 1))
                    : _createCommentVNode("", true),
                  (controle.dadosCliente?.cliente.cpfConjuge)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, " CPF Conjuge: " + _toDisplayString(controle.dadosCliente?.cliente.cpfConjuge), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (controle.ver = ''))
            }, "Voltar")
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == 'meusDependentes')
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _hoisted_58,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.dadosCliente?.dependentes, (dependente) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-12",
              key: dependente.dependenteId
            }, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("h5", _hoisted_61, _toDisplayString(dependente.nome), 1),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, "Parentesco: " + _toDisplayString(dependente.parentesco), 1),
                    _createElementVNode("div", _hoisted_64, "Nascimento: " + _toDisplayString(_unref(fdata)(dependente.dataNascimento)), 1)
                  ])
                ])
              ])
            ]))
          }), 128)),
          (!controle.dadosCliente?.dependentes || controle.dadosCliente?.dependentes.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, " Nenhum dependente cadastrado. "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (controle.ver = ''))
            }, "Voltar")
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == 'meusContratos')
      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
          _hoisted_68,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.dadosCliente?.contratos, (contrato) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-12",
              key: contrato.contratoId
            }, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("h5", _hoisted_73, "Contrato: " + _toDisplayString(contrato.contratoId), 1)
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("h5", _hoisted_75, "Plano: " + _toDisplayString(contrato.plano.nome), 1)
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("h5", _hoisted_77, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge rounded-pill", contrato.statusId === 2 ? 'badge-soft-success' : 'badge-soft-warning'])
                        }, _toDisplayString(contrato.status.descricao), 3)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, " Valor R$: " + _toDisplayString(_unref(f2dec)(contrato.plano.valor)), 1),
                    _createElementVNode("div", _hoisted_80, " Inicio: " + _toDisplayString(_unref(fdata)(contrato.dataInicio)), 1),
                    _createElementVNode("div", _hoisted_81, " Fim: " + _toDisplayString(_unref(fdata)(contrato.dataFim)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, " Assinado em: " + _toDisplayString(_unref(fdataHora)(contrato.dataAssinatura)), 1),
                    _hoisted_84,
                    _hoisted_85
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _createVNode(_component_RouterLink, {
                        to: { name: 'PainelClienteVerContrato', params: { contratoId: contrato.contratoId } },
                        class: "btn btn-primary btn-sm"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ver")
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      (contrato.dataAssinatura == null)
                        ? (_openBlock(), _createBlock(_component_RouterLink, {
                            key: 0,
                            to: { name: 'PainelClienteAssinarContrato', params: { contratoId: contrato.contratoId } },
                            class: "btn btn-warning btn-sm me-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Assinar ")
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (controle.ver = ''))
            }, "Voltar")
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == 'meusBoletos')
      ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
          _hoisted_91,
          _hoisted_92,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.dadosCliente?.mensalidades.filter(a=> a.dataPagamento == null), (parcela) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-12",
              key: parcela.mensalidadeId
            }, [
              _createVNode(Parcela, { parcela: parcela }, null, 8, ["parcela"])
            ]))
          }), 128)),
          _hoisted_93,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.dadosCliente?.mensalidades?.filter(a=> a.dataPagamento != null), (parcela) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-12",
              key: parcela.mensalidadeId
            }, [
              _createVNode(Parcela, { parcela: parcela }, null, 8, ["parcela"])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (controle.ver = ''))
            }, "Voltar")
          ])
        ]))
      : _createCommentVNode("", true),
    (controle.ver == '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
          _hoisted_96,
          _createElementVNode("div", _hoisted_97, [
            _hoisted_98,
            _withDirectives(_createElementVNode("input", {
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((controle.filtrosParceiros.pesquisa) = $event)),
              onInput: _cache[10] || (_cache[10] = ($event: any) => (buscarParceiros())),
              placeholder: "Nome do parceiro"
            }, null, 544), [
              [_vModelText, controle.filtrosParceiros.pesquisa]
            ])
          ]),
          _createElementVNode("div", _hoisted_99, [
            _hoisted_100,
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((controle.filtrosParceiros.categoriaId) = $event)),
              onChange: _cache[12] || (_cache[12] = ($event: any) => (buscarParceiros()))
            }, [
              _hoisted_101,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.dadosCliente?.categorias, (categoria) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: categoria.categoriaId,
                  value: categoria.categoriaId
                }, _toDisplayString(categoria.descricao), 9, _hoisted_102))
              }), 128))
            ], 544), [
              [_vModelSelect, controle.filtrosParceiros.categoriaId]
            ])
          ]),
          _createElementVNode("div", _hoisted_103, [
            _hoisted_104,
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((controle.filtrosParceiros.cidadeId) = $event)),
              onChange: _cache[14] || (_cache[14] = ($event: any) => (buscarParceiros()))
            }, [
              _hoisted_105,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.cidades, (cidade) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: cidade.cidadeId,
                  value: cidade.cidadeId
                }, _toDisplayString(cidade.nome) + " - " + _toDisplayString(cidade.estado), 9, _hoisted_106))
              }), 128))
            ], 544), [
              [_vModelSelect, controle.filtrosParceiros.cidadeId]
            ])
          ]),
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("a", {
              class: "btn btn-primary btn-sm mb-2 mt-4",
              href: "javascript:void(0);",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (verTodosParceiros()))
            }, " Ver todos ")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.parceiros, (parceiro) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-3",
              key: parceiro.parceiroId
            }, [
              _createElementVNode("div", _hoisted_108, [
                _createElementVNode("img", {
                  src: `${parceiro.arquivo}`,
                  class: "card-img-top",
                  alt: "..."
                }, null, 8, _hoisted_109),
                _createElementVNode("div", _hoisted_110, [
                  _createElementVNode("h6", _hoisted_111, _toDisplayString(parceiro.nome), 1),
                  _createElementVNode("div", _hoisted_112, _toDisplayString(parceiro.logradouro != null ? parceiro.logradouro + ' ' +
                        parceiro.numero + ' - ' : '') + " " + _toDisplayString(parceiro.bairro), 1),
                  _createElementVNode("div", _hoisted_113, _toDisplayString(parceiro.cidade.nome) + "/" + _toDisplayString(parceiro.cidade.estado), 1),
                  (parceiro.valorDescontoIni != null && parceiro.valorDescontoIni > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_114, " Desconto: de " + _toDisplayString(parceiro.valorDescontoIni) + " % até " + _toDisplayString(_unref(f2dec)(parceiro.valorDesconto)) + " % ", 1))
                    : _createCommentVNode("", true),
                  (parceiro.valorDescontoIni == null || parceiro.valorDescontoIni == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_115, " Desconto: " + _toDisplayString(_unref(f2dec)(parceiro.valorDesconto)) + " % ", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_116, "Telefone: " + _toDisplayString(parceiro.telefone), 1),
                  _createElementVNode("div", _hoisted_117, [
                    _createVNode(_component_RouterLink, {
                      to: { name: 'PainelClienteParceiro', params: { parceiroId: parceiro.parceiroId } },
                      class: "btn btn-primary btn-sm text-center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Ver detalhes")
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ])
              ])
            ]))
          }), 128)),
          (controle.parceiros.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_118, _hoisted_120))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(MsgBox, {
      id: 'janSair',
      titulo: 'Atenção',
      exibir: controle.janSair,
      onOnFechou: _cache[16] || (_cache[16] = ($event: any) => (controle.janSair = false)),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[17] || (_cache[17] = ($event: any) => (sair()))
    }, {
      default: _withCtx(() => [
        _hoisted_121
      ]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})